import { FilterAutocomplete } from '../baseInputTypes/FilterAutocomplete'

type Props = {}
export const RPM = (props: Props) => (
  <FilterAutocomplete
    label="RPM"
    fieldName={'rpms'}
    fieldPath={'productInformation.rpms'}
  />
)
